import http from '@plugins/axios';
import { queryString } from '../../../utils/format';

export const actions = {
  async fetch({ rootState }, payload) {
    const id = rootState.auth.instansi_id;
    return await http.get(`/psp/i/${id}/kp-lokakarya-rekap?${queryString(payload.params)}`).then(({ data }) => data);
  },

  async getDetail({ rootState }, payload) {
    const id = rootState.auth.instansi_id;
    return await http.get(`/psp/i/${id}/kp-lokakarya-rekap/${payload.id}`).then(({ data }) => data);
  },
};
